import Vue from 'vue';
import axios from "axios";
import userService from '../_services/user.service';

const config = {
    baseURL: process.env.VUE_APP_BASE_URL || '',
    timeout: 60 * 1000,
    withCredentials: true,
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    function (config) {
        const currentUser = userService.currentUserValue;
        if (currentUser) {
            config.headers.Authorization = `Bearer ${currentUser.token}`;
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        // Do something with response data
        return response;
    },
    function (error) {
        // Do something with response error
        return Promise.reject(error);
    }
);

Plugin.install = function (Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;
